exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".boolean-setting_checkbox_3CcG2 {\n    margin-right: 0.5rem;\n}\n\n.boolean-setting_label_1VmSA {\n    height: 32px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}", ""]);

// exports
exports.locals = {
	"checkbox": "boolean-setting_checkbox_3CcG2",
	"label": "boolean-setting_label_1VmSA"
};